module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "safety",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "safety"
    }
  }, [_c('h3', [_vm._v("Crime in " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v("\n  Part 1 and Part 2 crimes are defined by the FBI. "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Uniform_Crime_Reports#UCR_crime_categories"
    }
  }, [_vm._v("More info")]), _vm._v(" "), _c('br'), _vm._v("\n  For some cities, only Part 1 crime data is available.\n  "), _c('div', {
    staticStyle: {
      "min-width": "960px",
      "max-width": "960px",
      "height": "400px",
      "margin": "0 auto"
    },
    attrs: {
      "id": "crimeChart"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-012e4c2a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Safety.vue
// module id = 168
// module chunks = 1